import { render, staticRenderFns } from "./HiveMini.vue?vue&type=template&id=220f5642&scoped=true&"
import script from "./HiveMini.vue?vue&type=script&lang=js&"
export * from "./HiveMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f5642",
  null
  
)

export default component.exports